import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  customMessage?: string
}

export const DataNotAvailable = ({ customMessage }: Props) => {
  return (
    <Box alignItems="center" gap="s8" paddingY="s64" width="full">
      {!customMessage && (
        <>
          <Icon.Medium icon="alert-circle" color="grey1000" />
          <Text.Normal weight="bold">
            {i18n.t('ats.insights_page.empty_state.data_unavailable.title')}
          </Text.Normal>
        </>
      )}
      <Box textAlign="center" maxWidth="s600">
        <Text.Normal>
          {customMessage || i18n.t('ats.insights_page.empty_state.data_unavailable.description')}
        </Text.Normal>
      </Box>
    </Box>
  )
}
